import React, { useState, useContext, useEffect } from "react";
import PropTypes from "prop-types";
import { CartContext } from "components/cart";
import classNames from "lib/classNames";

const OneCheckUpSell = ({ one_check_up_sell }) => {
	const {
		cart_settings: { theme, rtl, money_format },
		add_to_cart,
		update_cart_item,
		Utils,
		isPreview,
		preview_product,
		productNotAddedToCart
	} = useContext(CartContext);
	let { product, text, truncate = true, truncate_length = 25, is_ticked_by_default, highlight } = one_check_up_sell;
	if ((!Object.keys(product || {}).length || (product && !product.id)) && isPreview)
		product = Utils.fakePreviewProducts("2.99", 1)[0];
	const [checked, setChecked] = useState(!productNotAddedToCart(product));
	const [userUncheck, setUserUncheck] = useState(0);

	const variant = product.variants.find(({ id }) => id.toString() == product.variant_id.toString());
	window.preview_one_click_upsell = () => {
		if (!product.isExample) preview_product(product, false);
	};
	const must_truncated = (text) => text.length > truncate_length;
	const truncate_name = (text) =>
		truncate ? `"${text.substring(0, truncate_length).trim()}${must_truncated(text) ? "..." : ""}"` : text;

	//TODO: remove {price} && {title} after updating old campaigns
	const formattedText = product
		? text
			.replace(
				/{{price}}/g,
				Utils.formatMoney(
					parseFloat(variant.price) * 100 * parseFloat(window.Shopify.currency.rate),
					money_format
				)
			)
			.replace(
				/{{title}}/g,
				`<b class='link' onclick='preview_one_click_upsell()' style="cursor:pointer;color:${Utils.formatColor(
					highlight || theme.primary
				)}">${truncate_name(product.title)}</b>`
			)
			.replace("{price}", Utils.formatMoney(parseFloat(variant.price) * 100, money_format))
			.replace(
				"{title}",
				`<b class='link' onclick='preview_one_click_upsell()' style="cursor:pointer;color:${Utils.formatColor(
					highlight || theme.primary
				)}">${truncate_name(product.title)}</b>`
			)
		: "";

	useEffect(() => {
		if (is_ticked_by_default) {
			if (isPreview) {
				setChecked(true);
			} else {
				if (userUncheck == 0) {
					setUserUncheck(1);
					if (productNotAddedToCart(product)) {
						handleOneCheckClick();
					} else {
						setChecked(true);
					}
				} else {
					setChecked(!productNotAddedToCart(product));
				}
			}
		} else {
			setChecked(!productNotAddedToCart(product));
		}
	}, [productNotAddedToCart(product), is_ticked_by_default]);

	const handleOneCheckClick = () => {
		const newStatus = !checked;
		setChecked(newStatus);
		if (newStatus && productNotAddedToCart(product))
			add_to_cart({
				variant_id: product.variant_id,
				product_handle: product.handle,
				quantity: 1,
				product
			});
		else update_cart_item({ variant_id: product.variant_id, quantity: 0 });
	};

	return (
		<div className={classNames("py-3 flex items-start justify-center")}>
			<button
				className={classNames(
					"w-4 h-4 flex-shrink-0 rounded border-2 cursor-pointer flex items-start justify-center",
					rtl ? "ml-1" : "mr-1"
				)}
				style={{
					marginTop: 2,
					color: Utils.formatColor(highlight || theme.primary),
					borderColor: Utils.formatColor(highlight || theme.primary),
					width: "fit-content",
					height: "fit-content",
					minHeight: "20px", // popular theme issue
					padding: 1
				}}
				onClick={handleOneCheckClick}
			>
				<svg
					aria-hidden="true"
					focusable="false"
					data-icon="check"
					style={{ width: 13, height: 13 }}
					role="img"
					xmlns="http://www.w3.org/2000/svg"
					viewBox="0 0 512 512"
					className={classNames({ "opacity-0": !checked })}
				>
					<path
						fill="currentColor"
						d="M173.898 439.404l-166.4-166.4c-9.997-9.997-9.997-26.206 0-36.204l36.203-36.204c9.997-9.998 26.207-9.998 36.204 0L192 312.69 432.095 72.596c9.997-9.997 26.207-9.997 36.204 0l36.203 36.204c9.997 9.997 9.997 26.206 0 36.204l-294.4 294.401c-9.998 9.997-26.207 9.997-36.204-.001z"
					></path>
				</svg>
			</button>
			<div
				dangerouslySetInnerHTML={{
					__html: formattedText
				}}
			/>
		</div>
	);
};

OneCheckUpSell.propTypes = {};

export default OneCheckUpSell;
